var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20.3996C13.245 20.3996 13.0312 20.3139 12.8587 20.1424C12.6862 19.9709 12.6 19.7584 12.6 19.5049C12.6 19.2514 12.6862 19.0371 12.8587 18.8621C13.0312 18.6871 13.245 18.5996 13.5 18.5996H16.5C16.755 18.5996 16.9687 18.6854 17.1412 18.8569C17.3137 19.0284 17.4 19.2409 17.4 19.4944C17.4 19.7479 17.3137 19.9621 17.1412 20.1371C16.9687 20.3121 16.755 20.3996 16.5 20.3996H13.5ZM9.89998 15.8996C9.64498 15.8996 9.43123 15.8139 9.25873 15.6424C9.08623 15.4709 8.99998 15.2584 8.99998 15.0049C8.99998 14.7514 9.08623 14.5371 9.25873 14.3621C9.43123 14.1871 9.64498 14.0996 9.89998 14.0996H20.1C20.355 14.0996 20.5687 14.1854 20.7412 14.3569C20.9137 14.5284 21 14.7409 21 14.9944C21 15.2479 20.9137 15.4621 20.7412 15.6371C20.5687 15.8121 20.355 15.8996 20.1 15.8996H9.89998ZM7.49998 11.3996C7.24498 11.3996 7.03123 11.3139 6.85873 11.1424C6.68623 10.9709 6.59998 10.7584 6.59998 10.5049C6.59998 10.2514 6.68623 10.0371 6.85873 9.86211C7.03123 9.68711 7.24498 9.59961 7.49998 9.59961H22.5C22.755 9.59961 22.9687 9.68536 23.1412 9.85686C23.3137 10.0284 23.4 10.2409 23.4 10.4944C23.4 10.7479 23.3137 10.9621 23.1412 11.1371C22.9687 11.3121 22.755 11.3996 22.5 11.3996H7.49998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.c77dc262fd056631f9d678a2260a9636.svg";
export { ForwardRef as ReactComponent };